import Vue from "vue";
import Router from "vue-router";
import index from "./views/index.vue";
import goodsIndex from "./views/goodsIndex.vue";
import goods from "./views/goods.vue";
import goodsTag from "./views/goodsTag.vue";
import goodsCreate from "./views/goodsCreate.vue";
import goodsDsCreate from "./views/goodsDsCreate.vue";
import goodsDetail from "./views/goodsDetail.vue";
import oilGunIndex from "./views/oilGunIndex.vue";
import oilGun from "./views/oilGun.vue";
import tableIndex from "./views/tableIndex.vue";
import table from "./views/table.vue";
import tableClassify from "./views/tableClassify.vue";
import tableRegion from "./views/tableRegion.vue";
import settingIndex from "./views/settingIndex.vue";
import settingThirdPlatform from "./views/settingThirdPlatform.vue";
import settingShop from "./views/settingShop.vue";
import settingDsShop from "./views/settingDsShop.vue";
import settingDelivery from "./views/settingDelivery.vue";
import settingAuth from "./views/settingAuth.vue";
import settingAccount from "./views/settingAccount.vue";
import settingFreight from "./views/settingFreight.vue";
import addFreightTmplate from "./views/addFreightTmplate.vue";
import settingCertification from "./views/settingCertification.vue";
import settingPrintSplit from "./views/settingPrintSplit.vue";
import settingPrintNomal from "./views/settingPrintNomal.vue";
import settingPrintTemplate from "./views/settingPrintTemplate.vue";
import settingHardware from "./views/settingHardware.vue";
import settingShopService from "./views/shopService";
import enterpriseProfile from "./views/enterpriseProfile.vue";
import configurationAfterPayment from "./views/configurationAfterPayment.vue";
import touchDrainageCard from "./views/touchDrainageCard.vue";
import touchDrainageCardNew from "./views/touchDrainageCardNew.vue";
import settingFreshDistribution from "./views/settingFreshDistribution";
import settingFreshDistributionBase from "./views/settingFreshDistributionBase";
import orderIndex from "./views/orderIndex.vue";
import order from "./views/order.vue";
import orderService from "./views/orderService.vue";
import dsOrder from "./views/dsOrder.vue";
import bargainingOrder from "./views/bargainingOrder.vue";
import reserveOrder from "./views/reserveOrder.vue";
import groupPurcharseOrder from "./views/groupPurcharseOrder.vue";
import pointsExchangeOrder from "./views/pointsExchangeOrder.vue";
import AIdraw from "./views/AIdraw.vue";
import AIcopywriting from "./views/AIcopywriting.vue";
import vipIndex from "./views/vipIndex.vue";
import vip from "./views/vip.vue";
import vipCard from "./views/vipCard.vue";
import consumeDetail from "./views/consumeDetail.vue";
import applyList from "./views/applyList.vue";
import cardActivity from "./views/cardActivity.vue";
import addVipcard from "./views/addVipcard.vue";
import cardConsume from "./views/cardConsume.vue";
import cardCoupon from "./views/cardCoupon.vue";
import couponList from "./views/couponList.vue";
import cardCouponIndex from "./views/cardCouponIndex";
import cardCouponList from "./views/cardCouponList.vue";
import allianceCoupon from "./views/allianceCoupon.vue";
import shopIndex from "./views/shopIndex.vue";
import shop from "./views/shop.vue";
import shopStaff from "./views/shopStaff.vue";
import shopsIndex from "./views/shopsIndex.vue";
import shops from "./views/shops.vue";
import realTimeInfoIndex from "./views/realTimeInfoIndex.vue";
import realTimeInfoList from "./views/realTimeInfoList.vue";
import realTimeInfoClassList from "./views/realTimeInfoClassList.vue";
import marketingIndex from "./views/marketingIndex.vue";
import marketing from "./views/marketing.vue";
import marketingMyorder from "./views/marketingMyorder.vue";
import marketingOrder from "./views/marketingOrder.vue";
import commentIndex from "./views/commentIndex.vue";
import comment from "./views/comment.vue";
import homeIndex from "./views/homeIndex.vue";
import home from "./views/home.vue";
import dsHome from "./views/dsHome.vue";
import homeOrder from "./views/homeOrder.vue";
import dataIndex from "./views/dataIndex.vue";
import data from "./views/data.vue";
import dataGoods from "./views/dataGoods.vue";
import dataGoodsSale from "./views/dataGoodsSale.vue";
import menberData from "./views/menberData.vue";
import goManage from "./views/goManage.vue";
import loginIndex from "./views/loginIndex.vue";
import login from "./views/login.vue";
import platformSelection from "./views/platformSelection.vue";
import manageData from "./views/manageData.vue";
import loginForget from "./views/forgetPassword.vue";
import loginRegister from "./views/registerForm.vue";
import messageIndex from "./views/messageIndex.vue";
import message from "./views/message.vue";
import messageInfo from "./views/messageInfo.vue";
import groupPurchase from "./views/groupPurchase.vue";
import bargin from "./views/bargin.vue";
import barginDetail from "./views/barginDetail.vue";
import barginAddAndEdit from "./views/barginAddAndEdit.vue";
import videoAccountActivitiesAddAndEdit from "./views/videoAccountActivitiesAddAndEdit.vue";
import vipBirthdayActivity from "./views/vipBirthdayActivity.vue";
import pointsExchange from "./views/pointsExchange.vue";
import pointsExchangeDetail from "./views/pointsExchangeDetail.vue";
import pointsExchangeAddAndEdit from "./views/pointsExchangeAddAndEdit.vue";
import marketingActivity from "./views/marketingActivity.vue";
import marketingActivityAddAndEdit from "./views/marketingActivityAddAndEdit.vue";
import bdmItemList from "./views/bdmItemList.vue";
import bdmItemAdd from "./views/bdmItemAdd.vue";
import groupPurchaseIndex from "./views/groupPurchaseIndex.vue";
import groupPurchaseDetail from "./views/groupPurchaseDetail.vue";
import addAndEdit from "./views/addAndEdit.vue";
import queueIndex from "./views/queueIndex.vue";
import queue from "./views/queue.vue";
import queueReserve from "./views/queueReserve.vue";
import appltIndex from "./views/appltIndex.vue";
import applt from "./views/applt.vue";
import appltCourse from "./views/appltCourse.vue";
import appltAliRegisterGuide from "./views/appltAliRegisterGuide.vue";
import appltInfo from "./views/appltInfo.vue";
import appltSetting from "./views/appltSetting.vue";
import appltPickuppoint from "./views/appltPickuppoint.vue";
import appltTemplate from "./views/appltTemplate.vue";
import appltQrCode from "./views/appltQrCode.vue";
import appltUserCode from "./views/appltUserCode.vue";
import appltDecoration from "./views/appltDecoration.vue";
import createMiniProgram from "./views/createMiniProgram.vue";
import customerIcon from "./views/customerIcon.vue";
import payManageIndex from "./views/payManageIndex.vue";
import payManageMechanism from "./views/payManageMechanism.vue";
import payManageBill from "./views/payManageBill.vue";
import payManageProject from "./views/payManageProject.vue";
import distributionIndex from "./views/distributionIndex.vue";
import distributionSetting from "./views/distributionSetting.vue";
import distributionList from "./views/distributionList.vue";
import distributionShopRelationshipList from "./views/distributionShopRelationshipList.vue";
import distributionRelationshipList from "./views/distributionRelationshipList.vue";
import distributionWithdrawalRecord from "./views/distributionWithdrawalRecord.vue";
import distributionApplicationRecord from "./views/distributionApplicationRecord.vue";
import msgIndex from "./views/msgIndex.vue";
import msgManage from "./views/msgManage.vue";
import equityCardIndex from "./views/equityCardIndex.vue";
import equityCardManage from "./views/equityCardManage.vue";
import equityCardList from "./views/equityCardList.vue";
import equityCardWriteOffRecord from "./views/equityCardWriteOffRecord.vue";
import serviceIndex from "./views/serviceIndex.vue";
import service from "./views/service.vue";
import serviceCreate from "./views/serviceCreate.vue";
import serviceDetail from "./views/serviceDetail.vue";
import priceChangeManage from "./views/priceChangeManage.vue";
import serviceTag from "./views/serviceTag.vue";
import bookingIndex from "./views/bookingIndex.vue";
import bookingList from "./views/bookingList.vue";
import bookingBoard from "./views/bookingBoard.vue";
import bookingSettingIndex from "./views/bookingSettingIndex.vue";
import bookingSetting from "./views/bookingSetting.vue";
import craftsmanManage from "./views/craftsmanManage.vue";
import craftsmanSchedule from "./views/craftsmanSchedule.vue";
import craftsmanScheduleManage from "./views/craftsmanScheduleManage.vue";
import craftsmanScheduleShiftManage from "./views/craftsmanScheduleShiftManage.vue";
import craftsmanEdit from "./views/craftsmanEdit.vue";
import homeMYOrder from "./views/homeMYOrder.vue";
import homeOrderPay from "./views/homeOrderPay.vue";
import wifiShare from "./views/wifiShare.vue";
import vipEquityManage from "./views/vipEquityManage.vue";
import matrixCode from "./views/matrixCode.vue";
import performanceStatistics from "./views/performanceStatistics.vue";
import canteen from "./views/canteen.vue";
import floor from "./views/floor.vue";
import floorDetail from "./views/floorDetail.vue";
import luckyLottery from "./views/luckyLottery.vue";
import luckyLotteryCreateAndEdit from "./views/luckyLotteryCreateAndEdit.vue";
import invoicingIndex from "./views/invoicingIndex.vue";
import invoicing from "./views/invoicing.vue";
import invoicingSet from "./views/invoicingSet.vue";
import editSupplier from "./views/editSupplier.vue";
import addClassify from "./views/addClassify.vue";
import goodsPurchase from "./views/goodsPurchase.vue";
import addGoodsPurchase from "./views/addGoodsPurchase.vue";
import goodsPurchaseReturn from "./views/goodsPurchaseReturn.vue";
import addGoodsPurchaseReturn from "./views/addGoodsPurchaseReturn.vue";
import stockCheck from "./views/stockCheck.vue";
import stockInquiry from "./views/stockInquiry.vue";
import goodsChange from "./views/goodsChange.vue";
import chooseGoodsPurchasePrice from "./views/chooseGoodsPurchasePrice.vue";
import chooseGoods from "./views/chooseGoods.vue";
import InventoryDetail from "./views/InventoryDetail.vue";
import singleStockInquiry from "./views/singleStockInquiry.vue";
import stockFlowList from "./views/stockFlowList.vue";
import goodsPurchaseDetail from "./views/goodsPurchaseDetail.vue";
import goodsChangeDetail from "./views/goodsChangeDetail.vue";
import stockFlowDetail from "./views/stockFlowDetail.vue";
import stockFlowTransferDetail from "./views/stockFlowTransferDetail.vue";
import putGoodsInStock from "./views/putGoodsInStock.vue";
import unitManagement from "./views/unitManagement.vue";
import orderManagment from "./views/orderManagment.vue";
import orderDetails from "./views/orderDetails.vue";
import returnOfTheTreasury from "./views/returnOfTheTreasury.vue";
import orderRefund from "./views/orderRefund.vue";
import returnsAndRefunds from "./views/returnsAndRefunds.vue";
import chooseAddGoods from "./views/chooseAddGoods.vue";
import chooseReturnGoods from "./views/chooseReturnGoods.vue";
import goodsChangeAdd from "./views/goodsChangeAdd.vue";
import InventoryGoods from "./views/InventoryGoods.vue";
import goodsPurchaseReturnDetail from "./views/goodsPurchaseReturnDetail.vue";
import stockFlowReturnDetail from "./views/stockFlowReturnDetail.vue";
import stockFlowInventoryDetail from "./views/stockFlowInventoryDetail.vue";
import choosePurcharseGoods from "./views/choosePurcharseGoods.vue";
import choosePurcharseReturn from "./views/choosePurcharseReturn.vue";
import pypView from "./views/pypView.vue";
import deviceManageIndex from "./views/deviceManageIndex.vue";
import deviceManageMoneyCodeList from "./views/deviceManageMoneyCodeList.vue";
import deviceManageDeviceList from "./views/deviceManageDeviceList.vue";
import deviceManageUserFunc from "./views/deviceManageUserFunc.vue";

Vue.use(Router);
export default new Router({
  routes: [
    {
      path: "/",
      component: index,
      children: [
        {
          path: "/",
          component: homeIndex,
          children: [
            {
              path: "/",
              component: home,
            },
            {
              path: "/dsHome",
              component: dsHome,
            },
            {
              path: "/home/order",
              component: homeOrder,
            },
          ],
        },
        {
          path: "/",
          component: goodsIndex,
          children: [
            {
              path: "/goods",
              component: goods,
            },
            {
              path: "/goods/tag",
              component: goodsTag,
            },
            {
              path: "/goods/tag/secondary",
              component: goodsTag,
            },
            {
              path: "/goods/edit",
              component: goodsCreate,
            },
            {
              path: "/goods/dsedit",
              component: goodsDsCreate,
            },
            {
              path: "/goods/detail",
              component: goodsDetail,
            },
            {
              path: "/goods/unit",
              component: unitManagement,
            },
          ],
        },
        {
          path: "/",
          component: serviceIndex,
          children: [
            {
              path: "/service",
              component: service,
            },
            {
              path: "/service/edit",
              component: serviceCreate,
            },
            {
              path: "/service/tag",
              component: serviceTag,
            },
            {
              path: "/service/detail",
              component: serviceDetail,
            },
            {
              path: "/service/priceChangeManage",
              component: priceChangeManage,
            },
          ],
        },
        {
          path: "/",
          component: bookingIndex,
          children: [
            {
              path: "/booking/list",
              component: bookingList,
            },
            {
              path: "/booking/board",
              component: bookingBoard,
            },
          ],
        },
        {
          path: "/",
          component: bookingSettingIndex,
          children: [
            {
              path: "/craftsman/bookingsetting",
              component: bookingSetting,
            },
            {
              path: "/craftsman/manage",
              component: craftsmanManage,
            },
            {
              path: "/craftsman/edit",
              component: craftsmanEdit,
            },
            {
              path: "/craftsman/schedule",
              component: craftsmanSchedule,
              children: [
                {
                  path: "/craftsman/schedule/manage",
                  component: craftsmanScheduleManage,
                },
                {
                  path: "/craftsman/schedule/shiftManage",
                  component: craftsmanScheduleShiftManage,
                },
              ],
            },
            {
              path: "/performanceStatistics",
              component: performanceStatistics,
            },
          ],
        },
        {
          path: "/",
          component: oilGunIndex,
          children: [
            {
              path: "/oilGun",
              component: oilGun,
            },
          ],
        },
        {
          path: "/",
          component: tableIndex,
          children: [
            {
              path: "/table",
              component: table,
            },
            {
              path: "/table/classify",
              component: tableClassify,
            },
            {
              path: "/table/region",
              component: tableRegion,
            },
          ],
        },
        {
          path: "/",
          component: settingIndex,
          children: [
            {
              path: "/setting",
              component: settingShop,
            },
            {
              path: "/settingDsShop",
              component: settingDsShop,
            },
            {
              path: "/setting/print/split",
              component: settingPrintSplit,
            },
            {
              path: "/setting/print/normal",
              component: settingPrintNomal,
            },
            {
              path: "/setting/print/template",
              component: settingPrintTemplate,
            },
            {
              path: "/setting/delivery",
              component: settingDelivery,
            },
            {
              path: "/setting/auth",
              component: settingAuth,
            },
            {
              path: "/setting/account",
              component: settingAccount,
            },
            {
              path: "/setting/freight",
              component: settingFreight,
            },
            {
              path: "/setting/addFreightTmplate",
              component: addFreightTmplate,
            },
            {
              path: "/setting/certification",
              component: settingCertification,
            },
            {
              path: "/setting/hardware",
              component: settingHardware,
            },
            {
              path: "/setting/shopService",
              component: settingShopService,
            },
            {
              path: "/setting/freshDistribution",
              component: settingFreshDistribution,
              children: [
                {
                  path: "/setting/freshDistribution/base",
                  component: settingFreshDistributionBase,
                },
                {
                  path: "/setting/freshDistribution/time",
                  component: appltSetting,
                },
                {
                  path: "/setting/freshDistribution/pickUpPoint",
                  component: appltPickuppoint,
                },
              ],
            },
            {
              path: "/setting/enterpriseProfile",
              component: enterpriseProfile,
            },
            {
              path: "/setting/wifiShare",
              component: wifiShare,
            },
            {
              path: "/setting/thirdPlatform",
              component: settingThirdPlatform,
            },
          ],
        },
        {
          path: "/",
          component: orderIndex,
          children: [
            {
              name: "order",
              path: "/order",
              component: order,
            },
            {
              name: "orderService",
              path: "/order/service",
              component: orderService,
            },
            {
              name: "orderEquityCard",
              path: "/order/equityCard",
              component: orderService,
            },
            {
              name: "dsOrder",
              path: "/order/dsOrder",
              component: dsOrder,
            },
            {
              name: "dyOrder",
              path: "/order/dyOrder",
              component: dsOrder,
            },
            {
              name: "bargainingOrder",
              path: "/order/bargainingOrder",
              component: bargainingOrder,
            },
            {
              path: "/order/takeout",
              component: order,
            },
            {
              path: "/order/tang",
              component: order,
            },
            {
              path: "/order/dy",
              component: order,
            },
            {
              path: "/order/offline",
              component: orderManagment,
            },
            {
              path: "/order/orderDetails",
              component: orderDetails,
            },
            {
              path: "/order/returnOfTheTreasury",
              component: returnOfTheTreasury,
            },
            {
              path: "/order/orderRefund",
              component: orderRefund,
            },
            {
              path: "/order/returnsAndRefunds",
              component: returnsAndRefunds,
            },
            {
              path: "/order/reserveOrder",
              component: reserveOrder,
            },
            {
              path: "/order/groupPurcharseOrder",
              component: groupPurcharseOrder,
            },
            {
              path: "/order/BDSHGroupPurcharseOrder",
              component: groupPurcharseOrder,
            },
            {
              path: "/order/pointsExchangeOrder",
              component: pointsExchangeOrder,
            },
          ],
        },
        {
          path: "/",
          component: vipIndex,
          children: [
            {
              path: "/vip",
              component: vip,
            },
            {
              path: "/vip/card",
              component: vipCard,
            },
            {
              path: "/vip/consumeDetail",
              component: consumeDetail,
            },
            {
              path: "/vip/applyList",
              component: applyList,
            },
            {
              path: "/vip/cardActivity",
              component: cardActivity,
            },
            {
              path: "/vip/cardConsume",
              component: cardConsume,
            },
            {
              path: "/vip/addVipcard",
              component: addVipcard,
            },
            {
              path: "/vip/equityManage",
              component: vipEquityManage,
            },
          ],
        },
        {
          path: "/",
          component: cardCouponIndex,
          children: [
            {
              path: "/cardCoupon",
              component: cardCoupon,
            },
            {
              path: "/cardCoupon/allianceCoupon",
              component: allianceCoupon,
            },
            {
              path: "/cardCoupon/cardCouponList",
              component: cardCouponList,
            },
            {
              path: "/cardCoupon/couponList",
              component: couponList,
            },
          ],
        },
        {
          path: "/",
          component: shopIndex,
          children: [
            {
              path: "/shop",
              component: shop,
            },
            {
              path: "/shop/staff",
              component: shopStaff,
            },
            {
              path: "/shop/canteen",
              component: canteen,
            },
            {
              path: "/shop/floor",
              component: floor,
            },
            {
              path: "/shop/floorDetail",
              component: floorDetail,
            },
          ],
        },
        {
          path: "/",
          component: shopsIndex,
          children: [
            {
              path: "/shops",
              component: shops,
            },
          ],
        },
        {
          path: "/",
          component: realTimeInfoIndex,
          children: [
            {
              path: "/realTimeInfo",
              component: realTimeInfoList,
            },
            {
              path: "/realTimeInfoClass",
              component: realTimeInfoClassList,
            },
          ],
        },
        {
          path: "/",
          component: marketingIndex,
          children: [
            {
              path: "/marketing",
              component: marketing,
            },
            {
              path: "/marketing/myorder",
              component: marketingMyorder,
            },
            {
              path: "/marketing/order",
              component: marketingOrder,
            },
          ],
        },
        {
          path: "/",
          component: commentIndex,
          children: [
            {
              name: "comment",
              path: "/comment",
              component: comment,
            },
          ],
        },
        {
          path: "/",
          component: dataIndex,
          children: [
            {
              path: "/data",
              component: data,
            },
            {
              path: "/data/goods",
              component: dataGoods,
            },
            {
              path: "/data/goodsSale",
              component: dataGoodsSale,
            },
            {
              path: "/data/menberData",
              component: menberData,
            },
            {
              path: "/data/goManage",
              component: goManage,
            },
          ],
        },
        {
          path: "/",
          component: messageIndex,
          children: [
            {
              path: "/message",
              component: message,
            },
            {
              path: "/message/info",
              component: messageInfo,
            },
          ],
        },
        {
          path: "/",
          component: groupPurchaseIndex,
          children: [
            {
              path: "/groupPurchase",
              component: groupPurchase,
            },
            {
              path: "/groupPurchase/detail",
              component: groupPurchaseDetail,
            },
            {
              path: "/groupPurchase/addAndEdit",
              component: addAndEdit,
            },
            {
              path: "/bargin",
              component: bargin,
            },
            {
              path: "/bargin/detail",
              component: barginDetail,
            },
            {
              path: "/bargin/addAndEdit",
              component: barginAddAndEdit,
            },
            {
              path: "/videoAccountActivities",
              component: bargin,
            },
            {
              path: "/videoAccountActivities/addAndEdit",
              component: videoAccountActivitiesAddAndEdit,
            },
            {
              path: "/vipBirthdayActivity",
              component: vipBirthdayActivity,
            },
            {
              path: "/exchange",
              component: pointsExchange,
            },
            {
              path: "/exchange/detail",
              component: pointsExchangeDetail,
            },
            {
              path: "/exchange/addAndEdit",
              component: pointsExchangeAddAndEdit,
            },
            {
              path: "/marketingActivity",
              component: marketingActivity,
            },
            {
              path: "/matrixCodeResource",
              component: marketingActivity,
            },
            {
              path: "/touchDrainageCard",
              component: touchDrainageCard,
            },
            {
              path: "/touchDrainageCardNew",
              component: touchDrainageCardNew,
            },
            {
              path: "/configurationAfterPayment",
              component: configurationAfterPayment,
            },
            {
              path: "/marketing/AddAndEdit",
              component: marketingActivityAddAndEdit,
            },
            {
              path: "/matrixCodeResource/AddAndEdit",
              component: marketingActivityAddAndEdit,
            },
            {
              path: "/marketing/bdmItem",
              component: bdmItemList,
            },
            {
              path: "/marketing/bdmItemAdd",
              component: bdmItemAdd,
            },
            {
              path: "/AIdraw",
              component: AIdraw,
            },
            {
              path: "/AIcopywriting",
              component: AIcopywriting,
            },
            {
              path: "/matrixCode",
              component: matrixCode,
            },
            {
              path: "/luckyLottery",
              component: luckyLottery,
            },
            {
              path: "/luckyLottery/createAndEdit",
              component: luckyLotteryCreateAndEdit,
            },
          ],
        },
        {
          path: "/",
          component: queueIndex,
          children: [
            {
              path: "/queue",
              component: queue,
            },
            {
              path: "/queue/reserve",
              component: queueReserve,
            },
          ],
        },
        {
          path: "/",
          component: payManageIndex,
          children: [
            {
              path: "/paymanage",
              component: payManageMechanism,
            },
            {
              path: "/paymanage/project",
              component: payManageProject,
            },
            {
              name: "payManageBill",
              path: "/paymanage/bill",
              component: payManageBill,
            },
          ],
        },
        {
          path: "/",
          component: appltIndex,
          children: [
            {
              path: "/applt",
              component: applt,
            },
            {
              path: "/appltCourse",
              component: appltCourse,
            },
            {
              path: "/appltAliRegisterGuide",
              component: appltAliRegisterGuide,
            },
            {
              path: "/applt/info",
              component: appltInfo,
            },
            {
              path: "/applt/template",
              component: appltTemplate,
            },
            {
              path: "/applt/qrCode",
              component: appltQrCode,
            },
            {
              path: "/applt/userCode",
              component: appltUserCode,
            },
            {
              path: "/applt/createMiniProgram",
              component: createMiniProgram,
            },
            {
              path: "/applt/customerIcon",
              component: customerIcon,
            },
            {
              path: "/applt/decoration",
              component: appltDecoration,
            },
          ],
        },
        {
          path: "/",
          component: distributionIndex,
          children: [
            {
              path: "/distribution",
              component: distributionSetting,
            },
            {
              path: "/distribution/list",
              component: distributionList,
            },
            {
              path: "/distribution/shopRelationship",
              component: distributionShopRelationshipList,
            },
            {
              path: "/distribution/relationship",
              component: distributionRelationshipList,
            },
            {
              path: "/distribution/withdrawalRecord",
              component: distributionWithdrawalRecord,
            },
            {
              path: "/distribution/applicationRecord",
              component: distributionApplicationRecord,
            },
          ],
        },
        {
          path: "/",
          component: msgIndex,
          children: [
            {
              path: "/msgManage",
              component: msgManage,
            },
          ],
        },
        {
          path: "/",
          component: equityCardIndex,
          children: [
            {
              path: "/equityCard/manage",
              component: equityCardManage,
            },
            {
              path: "/equityCard/list",
              component: equityCardList,
            },
            {
              path: "/equityCard/writeOffRecord",
              component: equityCardWriteOffRecord,
            },
          ],
        },
        {
          path: "/",
          component: invoicingIndex,
          children: [
            {
              name: "进销存管理",
              path: "/invoicing/manage",
              component: invoicing,
            },
            {
              name: "供货商管理",
              path: "/invoicing/invoicingSet",
              component: invoicingSet,
            },
            {
              name: "供货商管理",
              path: "/invoicing/editSupplier",
              component: editSupplier,
            },
            {
              name: "添加分类",
              path: "/invoicing/addClassify",
              component: addClassify,
            },
            {
              name: "进货单管理",
              path: "/invoicing/goodsPurchase",
              component: goodsPurchase,
            },
            {
              name: "进货单管理",
              path: "/invoicing/addGoodsPurchase",
              component: addGoodsPurchase,
            },
            {
              name: "进货退货单管理",
              path: "/invoicing/goodsPurchaseReturn",
              component: goodsPurchaseReturn,
            },
            {
              name: "进货退货单管理",
              path: "/invoicing/addGoodsPurchaseReturn",
              component: addGoodsPurchaseReturn,
            },
            {
              name: "库存盘点",
              path: "/invoicing/stockCheck",
              component: stockCheck,
            },
            {
              name: "库存查询",
              path: "/invoicing/stockInquiry",
              component: stockInquiry,
            },
            {
              name: "调拨单",
              path: "/invoicing/goodsChange",
              component: goodsChange,
            },
            {
              name: "选择进货单",
              path: "/invoicing/chooseGoodsPurchasePrice",
              component: chooseGoodsPurchasePrice,
            },
            {
              name: "选择商品",
              path: "/invoicing/chooseGoods",
              component: chooseGoods,
            },
            {
              name: "库存盘点",
              path: "/invoicing/InventoryDetail",
              component: InventoryDetail,
            },
            {
              name: "库存查询",
              path: "/invoicing/singleStockInquiry",
              component: singleStockInquiry,
            },
            {
              name: "商品库存",
              path: "/invoicing/stockFlowList",
              component: stockFlowList,
            },
            {
              name: "进货单管理",
              path: "/invoicing/goodsPurchaseDetail",
              component: goodsPurchaseDetail,
            },
            {
              name: "调拨单",
              path: "/invoicing/goodsChangeDetail",
              component: goodsChangeDetail,
            },
            {
              name: "商品库存",
              path: "/invoicing/stockFlowDetail",
              component: stockFlowDetail,
            },
            {
              name: "商品库存",
              path: "/invoicing/stockFlowTransferDetail",
              component: stockFlowTransferDetail,
            },
            {
              name: "入库",
              path: "/invoicing/putGoodsInStock",
              component: putGoodsInStock,
            },
            {
              name: "选择商品",
              path: "/invoicing/chooseAddGoods",
              component: chooseAddGoods,
            },
            {
              name: "选择商品",
              path: "/invoicing/chooseReturnGoods",
              component: chooseReturnGoods,
            },
            {
              name: "选择商品",
              path: "/invoicing/goodsChangeAdd",
              component: goodsChangeAdd,
            },
            {
              name: "库存盘点",
              path: "/invoicing/InventoryGoods",
              component: InventoryGoods,
            },
            {
              name: "进货退货单管理",
              path: "/invoicing/goodsPurchaseReturnDetail",
              component: goodsPurchaseReturnDetail,
            },
            {
              name: "进货退货单管理",
              path: "/invoicing/stockFlowInventoryDetail",
              component: stockFlowInventoryDetail,
            },
            {
              name: "进货退货单管理",
              path: "/invoicing/stockFlowReturnDetail",
              component: stockFlowReturnDetail,
            },
            {
              name: "选择进货单",
              path: "/invoicing/choosePurcharseGoods",
              component: choosePurcharseGoods,
            },
            {
              name: "选择进货单",
              path: "/invoicing/choosePurcharseGoods",
              component: choosePurcharseGoods,
            },
            {
              name: "选择进货单",
              path: "/invoicing/choosePurcharseReturn",
              component: choosePurcharseReturn,
            },
          ],
        },{
          path: "/",
          component: deviceManageIndex,
          children: [
            {
              name: "收款码管理",
              path: "/devicemanage/moneyCodeList",
              component: deviceManageMoneyCodeList,
            },
            {
              name: "设备管理",
              path: "/devicemanage/deviceList",
              component: deviceManageDeviceList,
            },
            {
              name: "收款码会员买单",
              path: "/devicemanage/moneyCodeMemberPay",
              component: deviceManageUserFunc,
            },
            {
              name: "云音响防逃单",
              path: "/devicemanage/moneyCodeCloudSoundNoPay",
              component: deviceManageUserFunc,
            },
          ],
        }
      ],
    },
    {
      path: "/",
      component: loginIndex,
      children: [
        {
          path: "/login",
          component: login,
        },
        {
          path: "/login/forget",
          component: loginForget,
        },
        {
          path: "/login/register",
          component: loginRegister,
        },
      ],
    },
    {
      path: "/home/my/order",
      component: homeMYOrder,
    },
    {
      path: "/home/order/pay",
      component: homeOrderPay,
    },
    {
      path: "/platformSelection",
      component: platformSelection,
    },
    {
      path: "/manageData",
      component: manageData,
    },
    {
      path: "/pypView",
      component: pypView,
      beforeEnter: (to, from, next) => {
        next();
      }
    },
    {
      path: "/touchDrainageCardNewIframe",
      component: touchDrainageCardNew,
    },
  ],
});
